import MENU_ITEMS from "constants/menu";
import { ACTIONS } from "constants/permissions";

export function initialPermission(data = []) {
  return data.reduce((output, item) => {
    const { module, subModuleKey, subModules = [] } = item;
    if (Array.isArray(subModules) && subModules.length !== 0) {
      subModules.forEach((subModule) => {
        output.push({
          ...subModule,
          module: `${module}/${subModuleKey}/${subModule?.module}`,
        });
      });
    }

    output.push(item);

    return output;
  }, []);
}

export function permissionHelper(UserGroup) {
  const { permissions = [], level: userLevel, isDefault } = UserGroup || {};
  const userPermissions = initialPermission(permissions);

  // Get all actions of the target resource
  function getResourceActions(resourceKey = "") {
    if (!userPermissions) {
      return undefined;
    }

    return userPermissions?.find((item) => item.module === resourceKey)
      ?.actions;
  }

  function isGranted(resources, actionKey = "") {
    if (!resources || (Array.isArray(resources) && resources.length === 0)) {
      return false;
    }

    // Need to match single resource
    if (!Array.isArray(resources)) {
      return getResourceActions(resources)?.includes(actionKey);
    }

    // Need to match multiple resources
    return resources.every(
      (resourceKey) => !!getResourceActions(resourceKey)?.includes(actionKey),
    );
  }

  function getGrantedMenuItems() {
    if (!Array.isArray(MENU_ITEMS) || MENU_ITEMS.length === 0) {
      return [];
    }

    return MENU_ITEMS.reduce((output, input) => {
      const { level, children, resources = [] } = input;

      if (level && !(level === userLevel && isDefault)) {
        return output;
      }

      if (Array.isArray(children) && children.length !== 0) {
        const filteredChildren = children.filter(
          (item) =>
            (!item.level || (item.level === userLevel && isDefault)) &&
            (isGranted(item.resources, ACTIONS.READ) ||
              item.resources.includes("*")),
        );

        if (filteredChildren.length !== 0) {
          output.push({
            ...input,
            children: filteredChildren,
          });
        }
      }

      if (
        resources.includes("*") ||
        (resources.length !== 0 && isGranted(resources, ACTIONS.READ))
      ) {
        output.push(input);
      }

      return output;
    }, []);
  }

  return {
    getResourceActions,
    getGrantedMenuItems,
  };
}

export function handleAction(action, isChecked, data = []) {
  const array = [...data];

  if (!action || (Array.isArray(action) && action.length === 0)) {
    return array;
  }

  // Handle multiple actions
  if (Array.isArray(action) && action.length !== 0) {
    let newArray = data;
    action.forEach((item) => {
      newArray = handleAction(item, isChecked, newArray);
    });
    return newArray;
  }

  // Append single action
  if (isChecked && !array.includes(action)) {
    array.push(action);
  }

  // Remove single action
  const removeIndex = array.indexOf(action);
  if (removeIndex !== -1 && !isChecked) {
    array.splice(removeIndex, 1);
  }

  return array;
}

export function cleanPermissionForChangingCheckbox(
  data = [],
  module = "",
  action = "",
  isChecked = false,
  // parentModule,
) {
  const Permissions = [...data];
  const moduleIndex = Permissions.findIndex((item) => item.module === module);

  const isNewModule = moduleIndex === -1;

  // const shouldNotRemovePermissionFromMandatory =
  //   parentModule &&
  //   Permissions.find((item) => item.module === parentModule)?.actions.length !==
  //     0 &&
  //   !isChecked;
  //
  // if (shouldNotRemovePermissionFromMandatory) {
  //   return Permissions;
  // }

  if (isNewModule) {
    Permissions.push({
      module,
      actions: handleAction(action, isChecked),
    });
  } else {
    Permissions[moduleIndex].actions = handleAction(
      action,
      isChecked,
      Permissions[moduleIndex].actions,
    );
  }

  return Permissions;
}

export function mergeActions(modules = []) {
  return modules.reduce((acc, cur) => {
    const { actions = [] } = cur || {};
    actions.map((item) => {
      if (!acc.includes(item)) {
        acc.push(item);
      }
      return null;
    });
    return acc;
  }, []);
}
